import { getAllToolsForInstitution, createOrUpdateTool, getToolDetail, deleteMultipleTool, getToolProxies, crateOrUpdateToolProxy, deleteToolProxy } from '../api'

export const loadAllToolsForInstitution = ({ state, commit }) => {
  return getAllToolsForInstitution()
}

export const createTool = ({ state, commit }, tool) => {
  return createOrUpdateTool(tool)
}

export const loadToolDetail = ({ state, commit }, uuid) => {
  return getToolDetail(uuid)
}

export const deleteSeletedTool = ({ state, commit }, uuids) => {
  return deleteMultipleTool(uuids)
}

export const loadToolProxies = ({ state, commit }, uuid) => {
  return getToolProxies(uuid)
}

export const createToolProxy = ({ state, commit }, data) => {
  return crateOrUpdateToolProxy(data)
}

export const loadDeleteToolProxy = ({ state, commit }, uuid) => {
  return deleteToolProxy(uuid)
}



// WEBPACK FOOTER //
// ./src/app/tool/vuex/actions.js